import { useEffect } from 'react';

import { useEntity, useLine } from '../hooks';

import { closeEventSource, initEventSource, sanitizeLineId } from './creator';

export const useEventsSubscription = () => {
	const { userTs } = useEntity();
	const { selectedLine } = useLine();

	useEffect(() => {
		const validLine = sanitizeLineId(selectedLine);
		if (userTs && validLine) {
			initEventSource(userTs, validLine, true);
		} else if (!userTs) {
			closeEventSource();
		}
	}, [userTs, selectedLine]);
};
